import { NgModule } from '@angular/core';

import { ChartBarModule } from './chart-bar/chart-bar.module';
import { HeatingCurveModule } from './heating-curve/heating-curve.module';
import { TemperatureModule } from './temperature/temperature.module';
import { TimemanagerModule } from './timemanager/timemanager.module';

@NgModule({
  imports: [TemperatureModule, HeatingCurveModule, TimemanagerModule],
  exports: [TemperatureModule, HeatingCurveModule, TimemanagerModule, ChartBarModule],
})
export class FeaturesModule {}
